import { render, staticRenderFns } from "./vehicle-size.vue?vue&type=template&id=1054bf6b"
import script from "./vehicle-size.vue?vue&type=script&lang=js"
export * from "./vehicle-size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports